import React from 'react';
import Typography from 'apollo-react/components/Typography';

/**
 * Maps Typography variant to default HTML component for semantics and a11y.
 * Pass `component` explicitly to override.
 */
const VARIANT_TO_COMPONENT = {
  bodySmall: 'p',
  bodyDefault: 'p',
  subheadline: 'h3',
  subtitle: 'h3',
  title: 'h2',
  title2: 'h2',
  h6: 'h6',
  caption: 'span',
};

/**
 * Typography wrapper that sets a default HTML component per variant:
 * - bodySmall, bodyDefault → p (paragraph)
 * - subheadline, subtitle → h3
 * - title, title2 → h2
 * - h6 → h6
 * - caption → span
 *
 * Use the `component` prop to override the default for any variant.
 */
const StyledTypography = ({ variant, component, ...rest }) => {
  const as =
    component ?? (variant ? VARIANT_TO_COMPONENT[variant] : undefined) ?? 'p';
  return <Typography variant={variant} component={as} {...rest} />;
};

export default StyledTypography;
